!function (angular) {
    "use strict";
    var lookUpService = angular.module('service.LookUp', []);

    lookUpService.factory('lookUpService', ['$http', 'halClient', 'appSettings', 'storeService', function ($http, halClient, appSettings, storeService) {

        return {
            list: function (lookup) {
                if (lookup.indexOf("/") !== 0) lookup = "/" + lookup;

                return halClient.$get(appSettings.apiBaseUri + lookup);
            },

            get: function (lookup, id) {
                if (lookup.indexOf("/") !== 0) lookup = "/" + lookup;

                return halClient.$get(appSettings.apiBaseUri + lookup + "/" + id);
            }
        };
    }]);


    lookUpService.factory('machineService', ['$http', 'halClient', 'appSettings', 'storeService', function ($http, halClient, appSettings, storeService) {

        var findByStationAndCategoryUrl = appSettings.apiBaseUri + "/machine/query-by-storeId-and-stationId-and-machineCategoryId?storeId=";

        return {
            findByStationAndCategory: function (stationId, machineCategoryId) {
                return halClient.$get(findByStationAndCategoryUrl + storeService.getStore().id + "&stationId=" + stationId + "&machineCategoryId=" + machineCategoryId);
            }
        }
    }]);


    lookUpService.factory('machineCategoryService', ['$http', 'halClient', 'appSettings', 'storeService', function ($http, halClient, appSettings, storeService) {

        var findByStationUrl = appSettings.apiBaseUri + "/machineCategory/query-by-storeId-and-stationId?storeId=";

        return {
            findByStation: function (stationId) {
                return halClient.$get(findByStationUrl + storeService.getStore().id + "&stationId=" + stationId);
            }
        }
    }]);


    lookUpService.factory('providerService', ['$http', 'halClient', 'appSettings', 'storeService', function ($http, halClient, appSettings, storeService) {

        var findByMachineUrl = appSettings.apiBaseUri + "/serviceProvider/query-by-machineId-eventType?machineId=";
        var getDefaultCostsUrl = appSettings.apiBaseUri + "/defaultCost/query-by-serviceProviderId?serviceProviderId=";
        var availabilityUrl = appSettings.apiBaseUri + "/availability/query-by-serviceProviderId?serviceProviderId=";

        return {
            findByMachine: function (eventTypeGroupId, machineId) {
                if (eventTypeGroupId === null) {
                    eventTypeGroupId = 0;
                }
                return halClient.$get(findByMachineUrl + machineId + "&eventTypeGroupId=" + eventTypeGroupId);
            },

            getDefaultCosts: function (serviceProviderId) {
                return halClient.$get(getDefaultCostsUrl + serviceProviderId);
            },

            availability: function (serviceProviderId) {
                return halClient.$get(availabilityUrl + serviceProviderId);
            }
        }
    }]);


    lookUpService.factory('stationService', ['$http', 'halClient', 'appSettings', 'storeService', function ($http, halClient, appSettings, storeService) {

        var findUrl = appSettings.apiBaseUri + "/station?storeId=" + storeService.getStore().id;

        return {
            find: function () {
                return halClient.$get(findUrl);
            }
        }
    }]);

    lookUpService.factory('engineerService', ['$http', 'halClient', 'appSettings', function ($http, halClient, appSettings) {

        var findByServiceProviderUrl = appSettings.apiBaseUri + "/engineer/query-by-providerId?providerId=";

        return {
            findByServiceProvider: function (serviceProviderId) {
                return halClient.$get(findByServiceProviderUrl + serviceProviderId);
            }
        }
    }]);

    lookUpService.factory('hazardAssessmentService', ['$http', 'halClient', 'appSettings', function ($http, halClient, appSettings) {

        var findByStoreAndTimeUrl = appSettings.apiBaseUri + "/hazardAssessment/find?engineerId=";

        return {
            findByStoreAndTime: function (storeId, engineerId, time, serviceRequestId) {
                return halClient.$get(findByStoreAndTimeUrl + engineerId + "&storeId=" +storeId + "&signInTime=" + time + "&serviceRequestId=" + serviceRequestId);
            }
        }
    }]);

    lookUpService.factory('serviceProviderService', ['$http', 'halClient', 'appSettings', function ($http, halClient, appSettings) {

        var findByServiceRequestUrl = appSettings.apiBaseUri + "/serviceProvider/query-by-service-request?serviceRequestId=";

        return {
            findByServiceRequest: function (serviceRequestId) {
                return halClient.$get(findByServiceRequestUrl + serviceRequestId);
            }
        }
    }]);


    lookUpService.factory('controlMeasureService', ['halClient', 'appSettings', function (halClient, appSettings) {

        var findByPotentialHazardUrl = appSettings.apiBaseUri + "/controlMeasure/query-by-hazardId?hazardId=";

        return {
            findByPotentialHazard: function (potentialHazardId) {
                return halClient.$get(findByPotentialHazardUrl + potentialHazardId);
            }
        }
    }]);

    lookUpService.factory('componentMetaDataService', ['halClient', 'appSettings', function (halClient, appSettings) {

        var findPartsMetadataUrl = appSettings.apiBaseUri + "/componentMetadata/?size=6";

        return {
            findPartsMetadata: function (filter) {
                return halClient.$get(findPartsMetadataUrl + "&metaDataId=" + filter.id + "&description=" + filter.description + "&page=" + filter.page);
            }
        };
    }]);

    lookUpService.factory('serviceProviderResponseTimeService', ['halClient', 'appSettings', function (halClient, appSettings) {


        var responseTimes = function (serviceProviderId) {
            return appSettings.apiBaseUri + "/serviceProvider/" + serviceProviderId + "/responseTimes"
        }

        var hasResponseTimes = function (serviceProviderId) {
            return appSettings.apiBaseUri + "/serviceProvider/" + serviceProviderId + "/activeResponseTimeVariances"
        }

        return {
            getResponseTimeByServiceProviderId: function (serviceProviderId) {
                return halClient.$get(responseTimes(serviceProviderId));
            },

            hasResponseTimes: function (serviceProviderId) {
                return halClient.$get(hasResponseTimes(serviceProviderId));
            }
        }
    }]);

    lookUpService.factory("componentService", ['halClient', 'appSettings', function (halClient, appSettings) {

        function getPartsOnlyWarrantyEndPoint(serviceRequestId) {
            return appSettings.apiBaseUri + "/componentWarrantyCover/partsOnlyWarranty?serviceRequestId=" + serviceRequestId;
        }

        return {
            partsOnlyWarranty: function (serviceRequestId) {
                return halClient.$get(getPartsOnlyWarrantyEndPoint(serviceRequestId));
            }
        }
    }]);
}(angular)